import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

interface DesignatedOperator {
  id: number;
  name: string;
  longName: string | null;
  disabled: boolean;
}

interface PaginatedResponse<T> {
  content: T[];
  pageable: {
    pageNumber: number;
    pageSize: number;
    sort: {
      empty: boolean;
      sorted: boolean;
      unsorted: boolean;
    };
    offset: number;
    paged: boolean;
    unpaged: boolean;
  };
  last: boolean;
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
  sort: {
    empty: boolean;
    sorted: boolean;
    unsorted: boolean;
  };
  numberOfElements: number;
  empty: boolean;
}

export interface UseDesignatedOperatorsParams {
  page?: number;
  size?: number;
}

export function useDesignatedOperators({ page = 0, size = 200 }: UseDesignatedOperatorsParams = {}, enabled = true) {
  return useQuery<PaginatedResponse<DesignatedOperator>>({
    queryKey: ['designatedOperators', page, size],
    queryFn: async () => {
      // Use standard pagination values with alphabetical sorting by name
      const response = await axios.get<PaginatedResponse<DesignatedOperator>>('/designated-operators', {
        params: {
          page,
          size,
          sort: 'name,asc'
        }
      });
      
      return response.data;
    },
    enabled
  });
} 